"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var CircularProgress_1 = __importDefault(require("../CircularProgress"));
var styles_1 = require("../../styles");
var SETTINGS_CIRCULAR_PROGRESS = {
    size: 20
};
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    circularProgressRoot: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        marginTop: -SETTINGS_CIRCULAR_PROGRESS.size / 2,
        marginLeft: -SETTINGS_CIRCULAR_PROGRESS.size / 2
    }
}); });
var Button = function (_a) {
    var _b = _a.children, children = _b === void 0 ? '' : _b, classes = _a.classes, _c = _a.color, color = _c === void 0 ? 'default' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.variant, variant = _e === void 0 ? 'contained' : _e, _f = _a.size, size = _f === void 0 ? 'medium' : _f, _g = _a.disableElevation, disableElevation = _g === void 0 ? true : _g, _h = _a.disableFocusRipple, disableFocusRipple = _h === void 0 ? false : _h, _j = _a.disableRipple, disableRipple = _j === void 0 ? false : _j, endIcon = _a.endIcon, _k = _a.fullWidth, fullWidth = _k === void 0 ? false : _k, href = _a.href, startIcon = _a.startIcon, _l = _a.isLoading, isLoading = _l === void 0 ? false : _l, onClick = _a.onClick, _m = _a.component, component = _m === void 0 ? 'button' : _m, action = _a.action, id = _a.id, type = _a.type, ref = _a.ref;
    var internalClasses = useStyles();
    return (react_1.default.createElement(Button_1.default, { classes: classes, variant: variant, size: size, disableElevation: disableElevation, color: color, disabled: disabled || isLoading, disableFocusRipple: disableFocusRipple, disableRipple: disableRipple, endIcon: endIcon, fullWidth: fullWidth, href: href, startIcon: startIcon, onClick: onClick, component: component, action: action, id: id, type: type, ref: ref },
        children,
        isLoading && (react_1.default.createElement(CircularProgress_1.default, { size: SETTINGS_CIRCULAR_PROGRESS.size, classes: { root: internalClasses.circularProgressRoot } }))));
};
exports.default = Button;
